
import { Component, Mixins } from "vue-property-decorator";
import { DateFormatKinds, IDateStyle } from "../../../../../../documaker/domain/format/objects";
import { IDateStylePropertyEditable, instanceOfIDateStylePropertyEditable } from "../../../../../domain/editableFormat/properties";

@Component
export default class DateStylePropertyEditableMixin extends Mixins() {
  writePropertyWhenValid: (writer: (source: IDateStylePropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IDateStylePropertyEditable) => T, defaultValue: T) => T;

  get isDateStylePropertyEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfIDateStylePropertyEditable(s) && s.dateStyle().isEditable(), false);
  }

  get dateStyle(): IDateStyle {
    return this.readPropertyOrDefault(s => s.dateStyle().getValue(), { formatKind: DateFormatKinds.ymdStringAd, hasWeekDay: false });
  }

  set dateStyle(value: IDateStyle) {
    this.writePropertyWhenValid(s => s.dateStyle().setValue(value));
  }
}

